import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const ListApi = ({
  moduleType,
}: {
  moduleType: ModuleType;
}): Promise<AxiosResponse> => {
  const path = `/admin/list/${moduleType}`;
  return Api.getInstance().request.get(path);
};
export default ListApi;
